export enum CaptchaPlace {
    LOGIN_PHONE_PAGE = "login_phone_page",
    LOGIN_CODE_PAGE = "login_code_page",
    LOGIN_CHANNEL_PAGE = "login_channel_page",
    LOGIN_PASSWORD_PAGE = "login_password_page"
}